export const profilePhotoMessages = {
  de: {
    fileHint: "JPG, PNG oder WebP · maximal 5 MB. Nur das Profilbild wird geändert.",
    fileLabel: "Neues Profilbild",
    invalidFile: "Bitte ein JPG-, PNG- oder WebP-Bild bis 5 MB auswählen.",
    photoLabel: (name: string) => `Profilbild von ${name}`,
    saved: "Bild gespeichert. Bis zur Sicherheitsprüfung wird hier die lokale Vorschau angezeigt.",
    title: "Profilbild",
    unavailable: "Das Profilbild konnte nicht gespeichert werden.",
    uploading: "Bild wird hochgeladen …",
  },
  en: {
    fileHint: "JPG, PNG or WebP · maximum 5 MB. Only the profile photo is changed.",
    fileLabel: "New profile photo",
    invalidFile: "Choose a JPG, PNG, or WebP image up to 5 MB.",
    photoLabel: (name: string) => `Profile photo of ${name}`,
    saved: "Photo saved. The local preview is shown here while security review is pending.",
    title: "Profile photo",
    unavailable: "The profile photo could not be saved.",
    uploading: "Uploading photo…",
  },
} as const;
